import { AlertDialog } from "radix-ui";

const ConfirmPopupTitle = ({
  children,
  color,
  onClose,
}: {
  children: string;
  color: string;
  onClose: () => void;
}) => {
  return (
    <AlertDialog.Title className="flex h-10 w-full items-center justify-between gap-2.5 p-[0px_10px_0px_15px]">
      <div
        className="min-h-10 flex-grow content-center truncate p-0 text-[14px] font-normal leading-[1.5]"
        style={{ color }}
      >
        {children}
      </div>

      <button
        aria-label="Close popup"
        onClick={onClose}
        className="flex h-5 min-h-5 w-5 min-w-5 items-center justify-center rounded-[5px] bg-transparent p-0.5 outline-none hover:bg-white/[0.08] focus:bg-white/[0.08] focus:outline-none"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          className="text-[#cacdce] transition-colors hover:text-white"
        >
          <path
            d="M10.763 12L5.38 17.38l1.237 1.238L12 13.237l5.382 5.382 1.237-1.238L13.237 12l5.381-5.381-1.237-1.238L12 10.762l-5.38-5.38-1.238 1.237 5.38 5.38z"
            fill="currentColor"
          />
        </svg>
      </button>
    </AlertDialog.Title>
  );
};

export default ConfirmPopupTitle;
